<ui-modal #composer [header]="false" [footer]="false" size="lg">

	<!-- The form. -->
	<ng-container *ngIf="step === 'compose'">
		<h3 class="mb-1">Create follow-up</h3>
		<p class="text-secondary">Add an action against any CRM record.</p>

		<!-- Which record. First, because a follow-up always lives on one. -->
		<label class="crm-cmp-label">Related to <span class="text-primary">*</span></label>
		<button class="crm-cmp-record" (click)="openPicker()">
			<i class="wq wq-search mr-2"></i>
			<span *ngIf="!record" class="text-secondary flex-weight-1 text-left">Search and select a record…</span>
			<span *ngIf="record" class="flex-weight-1 text-left">
				<b>{{record.title}}</b>
				<span class="text-secondary text-small ml-2">{{record.type === 'lead' ? 'Lead' : 'Deal'}}</span>
			</span>
			<span class="text-primary text-small">{{record ? 'Change' : 'Choose'}}</span>
		</button>

		<div class="crm-cmp-modes">
			<button [class.active]="mode === 'note'" (click)="mode = 'note'">
				<i class="wq wq-notes mr-2"></i>Note
			</button>
			<button [class.active]="mode === 'meeting'" (click)="mode = 'meeting'">
				<i class="wq wq-schedule mr-2"></i>Meeting
			</button>
		</div>

		<label class="crm-cmp-label">
			{{mode === 'note' ? 'Note title' : 'Meeting title'}}
			<span *ngIf="mode === 'meeting'" class="text-primary">*</span>
		</label>
		<input class="form-control mb-3" maxlength="255"
			[placeholder]="mode === 'note' ? 'Add a clear title' : 'e.g. Site survey'"
			[(ngModel)]="title" [ngModelOptions]="{ standalone: true }">

		<ng-container *ngIf="mode === 'note'">
			<label class="crm-cmp-label">Note body <span class="text-primary">*</span></label>
			<div class="mb-3">
				<editor *ngIf="editorInit" [init]="editorInit" [allowedEvents]="[]" [(ngModel)]="body"
					[ngModelOptions]="{ standalone: true }"></editor>
			</div>
		</ng-container>

		<ng-container *ngIf="mode === 'meeting'">
			<div class="row">
				<div class="col-md-4 mb-3">
					<label class="crm-cmp-label">Duration</label>
					<select class="custom-select" [(ngModel)]="meeting.duration_minutes" [ngModelOptions]="{ standalone: true }">
						<option *ngFor="let d of durations" [ngValue]="d.value">{{d.label}}</option>
					</select>
				</div>
				<div class="col-md-4 mb-3">
					<label class="crm-cmp-label">Kind</label>
					<select class="custom-select" [(ngModel)]="meeting.method" [ngModelOptions]="{ standalone: true }">
						<option *ngFor="let m of methods" [value]="m.value">{{m.label}}</option>
					</select>
				</div>
				<div class="col-md-4 mb-3">
					<label class="crm-cmp-label">Where</label>
					<input class="form-control" placeholder="Address or meeting link"
						[(ngModel)]="meeting.location" [ngModelOptions]="{ standalone: true }">
				</div>
			</div>
		</ng-container>

		<div class="row">
			<div class="col-md-6 mb-3">
				<label class="crm-cmp-label">Follow-up date <span class="text-primary">*</span></label>
				<input type="date" class="form-control" [(ngModel)]="date" [ngModelOptions]="{ standalone: true }">
			</div>
			<div class="col-md-6 mb-3">
				<label class="crm-cmp-label">Follow-up time <span class="text-primary">*</span></label>
				<input type="time" class="form-control" [(ngModel)]="time" [ngModelOptions]="{ standalone: true }">
			</div>
		</div>

		<!-- What this will actually do, said before they do it — including the one thing that is
		     not obvious: a mention is what hands it to somebody else. -->
		<div class="alert alert-light border d-flex align-items-start">
			<i class="wq wq-info text-secondary mr-3 mt-1"></i>
			<div class="text-secondary text-small">
				This saves a {{mode}} on the record and adds a follow-up to Needs Your Attention.
				<ng-container *ngIf="mode === 'note'">
					<b *ngIf="mentioned.length">It is assigned to the first person you tagged.</b>
					<ng-container *ngIf="!mentioned.length">Tag somebody with @ to hand it to them; without one it stays on your list.</ng-container>
				</ng-container>
			</div>
		</div>

		<hr>
		<div class="d-flex align-items-center">
			<div class="flex-weight-1"></div>
			<button class="btn btn-medium mr-2" (click)="close()">Cancel</button>
			<button class="btn btn-primary nowrap" [disabled]="!canSave || saving" (click)="save()">
				<i class="wq wq-add mr-2"></i>Create follow-up
			</button>
		</div>
	</ng-container>

	<!-- The record chooser, a step above the form rather than inside it. -->
	<ng-container *ngIf="step === 'picker'">
		<h3 class="mb-1">Choose a record</h3>
		<p class="text-secondary">Select the record this follow-up belongs to.</p>

		<div class="input-group mb-3">
			<div class="input-group-prepend"><span class="input-group-text"><i class="wq wq-search"></i></span></div>
			<input type="search" class="form-control" placeholder="Search deals and leads by name"
				[(ngModel)]="search" (ngModelChange)="onSearch()" [ngModelOptions]="{ standalone: true }"
				autocomplete="chrome-off">
		</div>

		<ui-wait *ngIf="searching"></ui-wait>

		<div *ngIf="!searching" class="crm-cmp-results">
			<button *ngFor="let r of results" class="crm-cmp-result" (click)="choose(r)">
				<span class="crm-cmp-result-icon"><i class="wq" [ngClass]="r.type === 'lead' ? 'wq-target' : 'wq-handshake'"></i></span>
				<span class="flex-weight-1 text-left min-width-0">
					<b class="d-block text-truncate">{{r.title}}</b>
					<span class="text-secondary text-small">{{r.type === 'lead' ? 'Lead' : 'Deal'}}<span
						*ngIf="r.stage"> &middot; {{r.stage}}</span></span>
				</span>
				<i class="wq wq-chevron-right text-secondary"></i>
			</button>

			<div *ngIf="!results.length" class="text-secondary text-center py-4">
				Nothing matches "{{search}}".
			</div>
		</div>

		<hr>
		<div class="d-flex align-items-center">
			<button class="btn btn-medium" (click)="step = 'compose'">
				<i class="wq wq-arrow-left mr-2"></i>Back
			</button>
			<div class="flex-weight-1"></div>
			<!-- Said, because leaving a half-written note to go and find a record is exactly when
			     somebody worries they have lost it. -->
			<span class="text-secondary text-small">Your unfinished {{mode}} stays in the composer.</span>
		</div>
	</ng-container>
</ui-modal>
